<template>
  <Loading v-if="isPageLoading" />
  <div v-else>
    <div v-if="availableDiscount" class="fixed top-0 w-full z-10 mb-10">
      <Discount :discount="discount" />
    </div>
    <div :class="[availableDiscount ? 'pt-14 md:pt-10' : '']" class="min-h-screen flex flex-col bg-white">
      <div class="grid grid-cols-1 lg:grid-cols-2">
        <div class="py-6 px-8 sm:px-14">
          <div class="py-6 flex items-center space-x-6">
            <img class="h-6 sm:h-8 w-auto" :src="logoUrl" alt="MerchantLogo" />
            <span class="text-3xl font-bold text-black">X</span>
            <img class="h-6 sm:h-8 w-auto" src="@/assets/large_logo_estaly_black.png" alt="Estaly" />
          </div>
          <div class="py-6 relative inset-0 flex flex-col justify-center text-gray-900">
            <span class="text-3xl font-semibold">{{ marketing.headline }}</span>
          </div>
          <VeeForm
            v-slot="{ handleSubmit, values }"
            :validation-schema="schema"
            :initial-values="initialValues"
            :validate-on-mount="true"
            as="div"
          >
            <form
              @submit="
                formSubmitted = true;
                handleSubmit($event, submitLeadCreation);
              "
            >
              <div class="flex-1">
                <CategorySelector v-if="marketplace" :categories="categories" v-model="productCategory" />
              </div>

              <div class="flex-1 mt-4">
                <label :for="'productName'" class="block text-sm leading-6 text-gray-900 sm:pt-1.5 mb-2 font-semibold">
                  Nom du produit à assurer
                  <span class="text-red-600">*</span>
                </label>
                <Field
                  id="productName"
                  name="productName"
                  :validate-on-blur="false"
                  :validate-on-change="false"
                  v-model="values.productName"
                  :placeholder="exampleProductTitle"
                  class="block w-full rounded-md border border-gray-300 px-3 py-1.5 text-gray-900 shadow-xs sm:text-sm sm:leading-6"
                />
                <ErrorMessage name="productName" v-slot="{ message }">
                  <div class="text-sm text-red-600 block">
                    {{ formSubmitted && message ? message : "\u00A0" }}
                  </div>
                </ErrorMessage>
              </div>

              <div class="flex-1">
                <label :for="'productDate'" class="block text-sm leading-6 text-gray-900 sm:pt-1.5 mb-2 font-semibold">
                  Date d'achat
                  <span class="text-red-600">*</span>
                </label>
                <Field
                  id="productDate"
                  name="productDate"
                  type="date"
                  :validate-on-blur="false"
                  :validate-on-change="false"
                  v-model="values.productDate"
                  :max="new Date().toISOString().split('T')[0]"
                  class="block w-full rounded-md border border-gray-300 px-3 py-1.5 text-gray-900 shadow-xs sm:text-sm sm:leading-6"
                />
                <ErrorMessage name="productDate" v-slot="{ message }">
                  <div class="text-sm text-red-600 block">
                    {{ formSubmitted && message ? message : "\u00A0" }}
                  </div>
                </ErrorMessage>
              </div>

              <div class="flex flex-col space-x-0 sm:space-y-0 sm:space-x-4 sm:flex-row">
                <div class="flex-1">
                  <label
                    :for="'productPrice'"
                    class="block text-sm leading-6 text-gray-900 sm:pt-1.5 mb-2 font-semibold"
                  >
                    {{
                      productCategory == "bike"
                        ? "Prix d'achat du produit (accessoires inclus)"
                        : "Prix d'achat du produit"
                    }}
                    <span class="text-red-600">*</span>
                  </label>
                  <div class="relative">
                    <Field
                      id="productPrice"
                      name="productPrice"
                      :validate-on-blur="false"
                      :validate-on-change="false"
                      v-model="values.productPrice"
                      placeholder="2 500"
                      class="block w-full rounded-md border border-gray-300 px-3 py-1.5 text-gray-900 shadow-xs sm:text-sm sm:leading-6"
                    />
                    <span
                      class="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-3 text-gray-500 sm:text-sm"
                    >
                      EUR
                    </span>
                  </div>
                  <ErrorMessage name="productPrice" v-slot="{ message }">
                    <div class="text-sm text-red-600 block">
                      {{ formSubmitted && message ? message : "\u00A0" }}
                    </div>
                  </ErrorMessage>
                </div>
                <div class="flex-1">
                  <label
                    :for="'productReference'"
                    class="block text-sm leading-6 text-gray-900 sm:pt-1.5 mb-2 font-semibold"
                  >
                    Numéro de série du produit
                    <span class="text-red-600">*</span>
                  </label>
                  <Field
                    id="productReference"
                    name="productReference"
                    :validate-on-blur="false"
                    :validate-on-change="false"
                    v-model="values.productReference"
                    placeholder="Ex : SN123456789"
                    class="block w-full rounded-md border border-gray-300 px-3 py-1.5 text-gray-900 shadow-xs sm:text-sm sm:leading-6"
                  />
                  <ErrorMessage name="productReference" v-slot="{ message }">
                    <div class="text-sm text-red-600 block">
                      {{ formSubmitted && message ? message : "\u00A0" }}
                    </div>
                  </ErrorMessage>
                </div>
              </div>

              <div class="flex flex-col space-x-0 sm:space-x-4 sm:flex-row">
                <div class="flex-1">
                  <label :for="'email'" class="block text-sm leading-6 text-gray-900 sm:pt-1.5 mb-2 font-semibold">
                    Adresse email
                    <span class="text-red-600">*</span>
                  </label>
                  <Field
                    id="email"
                    name="email"
                    type="email"
                    :validate-on-blur="false"
                    :validate-on-change="false"
                    v-model="values.email"
                    placeholder="votre@email.com"
                    class="block w-full rounded-md border border-gray-300 px-3 py-1.5 text-gray-900 shadow-xs sm:text-sm sm:leading-6"
                  />
                  <ErrorMessage name="email" v-slot="{ message }">
                    <div class="text-sm text-red-600 block">
                      {{ formSubmitted && message ? message : "\u00A0" }}
                    </div>
                  </ErrorMessage>
                </div>
                <div class="flex-1">
                  <label
                    :for="'phoneNumber'"
                    class="block text-sm leading-6 text-gray-900 sm:pt-1.5 mb-2 font-semibold"
                  >
                    Numéro de téléphone
                    <span class="text-red-600">*</span>
                  </label>
                  <Field
                    id="phoneNumber"
                    name="phoneNumber"
                    type="tel"
                    :validate-on-blur="false"
                    :validate-on-change="false"
                    v-model="values.phoneNumber"
                    placeholder="+33 X XX XX XX XX"
                    class="block w-full rounded-md border border-gray-300 px-3 py-1.5 text-gray-900 shadow-xs sm:text-sm sm:leading-6"
                  />
                  <ErrorMessage name="phoneNumber" v-slot="{ message }">
                    <div class="text-sm text-red-600 block">
                      {{ formSubmitted && message ? message : "\u00A0" }}
                    </div>
                  </ErrorMessage>
                </div>
              </div>

              <div class="mt-5 flex flex-col space-y-2 space-x-0 sm:flex-row sm:space-x-2 sm:justify-between">
                <div class="flex justify-end">
                  <button
                    type="submit"
                    class="rounded-xl inline-flex items-center border py-2 px-4 text-sm font-medium text-white bg-primary-dark shadow-lg hover:opacity-90 focus:outline-hidden focus:shadow-none"
                    :disabled="isLoading"
                  >
                    Voir les tarifs
                  </button>
                </div>
                <div class="flex justify-end">
                  <a
                    class="underline inline-flex items-center py-2 px-4 text-sm font-medium cursor-pointer text-center text-gray-900"
                    :href="contractDetailsLink"
                    target="_blank"
                  >
                    {{ $t("Warranty details") }}
                  </a>
                </div>
              </div>
            </form>
          </VeeForm>
        </div>
        <div class="hidden sm:block">
          <img
            class="h-full w-full object-cover"
            src="https://cdn.prod.website-files.com/63498a366b0458cb05acecdb/65dfb1c170625ab215455f75_Estaly-une-experience-positive.webp"
            alt=""
          />
        </div>
      </div>
      <div class="bg-white">
        <OffersDetails :marketing="marketing" />
      </div>
    </div>
  </div>
</template>

<script>
import { Form as VeeForm, ErrorMessage, useForm, Field } from "vee-validate";
import * as yup from "yup";
import LeadsService from "@/api/services/leads";
import { mapActions } from "vuex";
import OffersDetails from "@/components/OffersDetails.vue";
import CategorySelector from "@/components/CategorySelector.vue";
import Discount from "@/components/subscription/Discount";
import { Loading, phoneRegex, isObjectValid, isArrayNotEmpty } from "@estaly/ui";

export default {
  components: {
    VeeForm,
    Field,
    ErrorMessage,
    OffersDetails,
    CategorySelector,
    Discount,
    Loading,
  },
  data: () => {
    const schema = yup.object({
      productName: yup.string().required("Le nom du produit est requis"),
      productPrice: yup.string().required("Le prix du produit est requis"),
      productReference: yup.string().required("La référence du produit est requise"),
      email: yup.string().required("L'email est requis").email("L'email n'est pas valide"),
      phoneNumber: yup
        .string()
        .required("Le numéro de téléphone est requis")
        .matches(phoneRegex, "Le numéro de téléphone n'est pas valide pour la France ou les départements d'outre-mer"),
      productDate: yup.string().required("La date d'achat est requise"),
    });

    return {
      schema,
      logoUrl: "",
      exampleProductTitle: "",
      marketing: "",
      productCategory: "",
      categories: [],
      discount: undefined,
      isLoading: false,
      isPageLoading: true,
      formSubmitted: false,
    };
  },

  beforeMount() {
    this.getStore();
  },

  mounted() {
    const query = this.$route.query;
    const { setFieldValue } = useForm();

    if (query.productName) setFieldValue("productName", query.productName);
    if (query.productReference) setFieldValue("productReference", query.productReference);
    if (query.email) setFieldValue("email", query.email);
    if (query.phoneNumber) setFieldValue("phoneNumber", query.phoneNumber);
    if (query.productDate) setFieldValue("productDate", query.productDate);
    if (query.productPrice) setFieldValue("productPrice", query.productPrice);
  },

  watch: {
    productCategory(newProductCategory) {
      this.getMarketingDetails(newProductCategory);
    },
  },

  computed: {
    contractDetailsLink() {
      const category = isArrayNotEmpty(this.categories)
        ? this.categories.find((category) => category.value === this.productCategory)
        : null;
      return isObjectValid(category) ? category.marketingPage : null;
    },
    availableDiscount() {
      return isObjectValid(this.discount.title);
    },
  },

  methods: {
    ...mapActions("notifications", ["notify"]),

    async getMarketingDetails(productCategory) {
      const storeShopName = this.$route.params.storeShop;
      const response = await LeadsService.getMarketingDetails(productCategory, storeShopName);

      if (!response?.success) return;

      this.marketing = response.data.store.marketingDetails.marketing;
      this.exampleProductTitle = response.data.store.exampleProductTitle;
    },

    async getStore() {
      const storeShopName = this.$route.params.storeShop;
      const response = await LeadsService.getStore(storeShopName);

      if (!response?.success) return;

      this.discount = response.data.store.discount;
      this.category = response.data.store.category;
      this.exampleProductTitle = response.data.store.exampleProductTitle;
      this.logoUrl = response.data.store.marketingDetails.logoUrl;
      this.marketing = response.data.store.marketingDetails.marketing;
      this.marketplace = response.data.store.marketplace;
      this.categories = response.data.store.categories;

      if (this.categories.length > 0) {
        const categoryFromQuery = this.$route.query.category;
        const matchingCategory = this.categories.find((cat) => cat.value === categoryFromQuery);
        const selectedCategory = matchingCategory ? matchingCategory.value : this.categories[0].value;
        await this.getMarketingDetails(selectedCategory);
        this.productCategory = selectedCategory;
      }

      this.isPageLoading = false;
    },

    async submitLeadCreation(values) {
      this.isLoading = true;
      const formattedProductPrice =
        typeof values.productPrice === "string"
          ? values.productPrice.replace(/\s/g, "").replace(",", ".")
          : values.productPrice;
      const params = {
        store: {
          store_shop_name: this.$route.params.storeShop,
        },
        lead: {
          customer: {
            email: values.email,
            phone: values.phoneNumber,
          },
          product: {
            title: values.productName,
            price: formattedProductPrice,
            reference_id: values.productReference,
            currency_code: "EUR",
          },
          category: this.productCategory,
          invitation_sent_by_estaly: false,
          transaction_date: values.productDate,
          source_channel: "public",
        },
      };

      const response = await LeadsService.create(params);
      setTimeout(() => {
        this.isLoading = false;
      }, 3000);

      if (!response?.success) return;

      const uniqueToken = response.data.lead.estaly_id;
      this.$router.push(`/subscription/${uniqueToken}`);
    },
  },
};
</script>
